import store from '@/store'

export function Work () {
  this.carNo = null
  this.brandModel = []
  this.color = 'black'

  this.ownerName = null
  this.phone = null

  this.consultantName = null
  this.id = null

  this.extraId = null
  this.enterTime = new Date()
  this.estimateDeliveryTime = null
  this.payMethodCode = 'customer'
  this.insuranceCompanyId = null
  this.consultantId = null
  this.remarks = null
  this.urgent = false
  this.isOutsideRework = 0
  this.outsideReworkReasonId = null

  this.lossDeterm = new LossDeterm()

  this.allowDisassemblyProcedure = true
  this.allowSheetMetalProcedure = true
  this.allowAssemblyProcedure = true
  this.allowPaintProcedure = true
  this.basicPaintWorkHour = null
}

export function LossDeterm () {
  this.repairType = 'COMMON'
  this.partsList = []
  this.sheetMetalPiece = 0
  this.paintArea = 0
  this.disassemblyWH = 0
  this.sheetMetalWH = 0
  this.assemblyWH = 0
  this.paintWH = 0
  this.cost = 0
}

export function Team () {
  this.name = null
  this.procedureIdList = []
  this.maxWorkNum = 1 // 可施工数量
  this.remarks = null
  this.status = 0
}

export function Procedure () {
  this.name = null
  this.type = null
  this.basicTypes = []
  this.workHourMin = 60
  this.status = 0
  this.remarks = null
}

export function Organ () {
  this.exposedCode = null
  this.name = null
  this.type = 'SHOP'
  this.carBandIds = []
  this.insuranceCompanyIds = []
  this.dispatchPattern = null
  this.sheetMetalDispatch2Team = false
  this.paintDispatch2Team = false
  this.contactName = null
  this.cellphone = null
  this.addressCode = ''
  this.address = null
  this.addressDetail = null
  this.remarks = null
  this.status = 0
  this.workshopCode = process.env.VUE_APP_CODE
  this.imageUrl = null
}

export function User () {
  this.name = null
  this.cellphone = null
  this.password = null
  this.avatarUrl = null
  this.status = 0

  this.positions = []
  this.permissions = []

  this.teamId = null
  this.technicianType = null
  this.technicianLevelId = null
  this.maxWorkNum = null
}

export function Brand () {
  this.code = null
  this.name = null
  this.status = 0
}

export function Model () {
  this.brandId = null
  this.name = null
  this.status = 0
}

export function Customer () {
  this.shopId = store.state.user.shopId
  this.name = null
  this.gender = null
  this.birthday = null
  this.qq = null
  this.remarks = null
  this.carNo = null
  this.color = null
  this.brandModel = []
}

export function Station () {
  this.name = null
  this.stationTypeCode = null
  this.area = 0
  this.workNum = 0
  this.remarks = null
  this.status = 0
}

export function Parts () {
  this.name = null
  this.typeCode = null
  this.brandIds = []
  this.remarks = null
  this.status = 0
}

export function PartsCoe () {
  this.partsId = null
  this.sheetMetalCoe = {
    NEW: [0, 0],
    LIGHT: [0, 0],
    MEDIUM: [0, 0],
    HEAVILY: [0, 0]
  }
  this.paintCoe = {
    NEW: [0, 0],
    LOCAL: [0, 0],
    HALF: [0, 0],
    FULL: [0, 0]
  }
  this.disassemblyCoe = [0, 0]
  this.assemblyCoe = [0, 0]
  this.quickCoe = [0, 0]
}

export function DictItem () {
  this.value = null
  this.type = null
}

export function Warehouse () {
  this.name = null
  this.code = null
  this.typeCode = null
  this.remarks = null
}

export function WarehousePos () {
  this.name = null
  this.code = null
  this.typeCode = null
  this.remarks = null
  this.warehouseId = null
}

export function Goods () {
  this.name = null
  this.code = null
  this.typeCode = null
  this.price = null
  this.unit = null
  this.unit2 = null
  this.unitRatio = null
  this.supplierCode = null
  this.remarks = null
  this.disabled = false
}

export function Inbound () {
  this.code = null
  this.inDate = new Date()
  this.warehouseId = null
  this.warehousePosId = null
  this.operatorUserAccount = null
  this.operatorUserName = null
  this.goodsList = []
  this.remarks = null
  this.status = 0
}

export function Outbound () {
  this.code = null
  this.outDate = new Date()
  this.warehouseId = null
  this.warehousePosId = null
  this.operatorUserAccount = null
  this.operatorUserName = null
  this.goodsList = []
  this.remarks = null
  this.logisticsCompany = null
  this.logisticsCode = null
  this.freight = null
  this.settlementAccount = null
  this.status = 0
}

export function Neiling () {
  this.code = null
  this.outDate = new Date()
  this.warehouseId = null
  this.warehousePosId = null
  this.operatorUserAccount = null
  this.operatorUserName = null
  this.goodsList = []
  this.remarks = null
  this.status = 0
}
